import { responsiveWrapper } from 'react-responsive-redux';

export const SmallScreen = responsiveWrapper({ maxWidth: 768 });

// below are uncommon/less-seen breakpoints

// SmallScreen upper boundary AND above
export const MQSpecial1 = responsiveWrapper({ minWidth: 768 });



// WEBPACK FOOTER //
// ./src/utils/responsive-mq.jsx